import { Chip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../helpers/formatingFunctions";
import DownloadButton from "../../../components/Fleet/DownloadButton/DownloadButton";
import UpdateYardRepairPopup from "../../../components/Fleet/UpdateYardRepairPopup/UpdateYardRepairPopup";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";

export const yardRepairsTableColumns: GridColDef[] = [
  { field: "unitNumber", headerName: "Unit number", width: 130 },
  {
    field: "rentCompanyName",
    headerName: "Rent Company Name",
    width: 180,
    valueFormatter: (params: any) => params || "N/A",
  },
  {
    field: "ownerCompanyName",
    headerName: "Company",
    width: 180,
    valueFormatter: (params: any) => params || "N/A",
  },
  {
    field: "driverFullName",
    headerName: "Driver",
    width: 180,
    valueFormatter: (params: any) => params || "N/A",
  },
  { field: "description", headerName: "Description", width: 250 },
  {
    field: "amount",
    headerName: "Amount",
    width: 180,
    valueFormatter: (value) =>
      value !== null && value !== undefined && value !== "" ? `$${value}` : "",
  },
  {
    field: "invoiceDate",
    headerName: "Invoice date",
    width: 180,
    valueFormatter: (value) => formatDate(value as string),
  },
  { field: "invoiceNumber", headerName: "Invoice number", width: 130 },
  { field: "authorizedBy", headerName: "Authorized by", width: 130 },
  { field: "mileage", headerName: "Mileage", width: 130 },
  {
    field: "isCompanyCharged",
    headerName: "Company Charged",
    width: 150,
    renderCell: (params) => {
      const value = params.value;
      const isUnset = value === null || value === undefined || value === "";
      const label = isUnset ? "No" : value ? "Yes" : "No";
      return <Chip label={label} color={value ? "success" : "default"} />;
    },
  },
  {
    field: "chargedCompanyAmount",
    headerName: "Company Charged Amount",
    width: 190,
    valueFormatter: (value) =>
      value !== null && value !== undefined && value !== "" ? `$${value}` : "",
  },
  {
    field: "isDriverCharged",
    headerName: "Driver Charged",
    width: 150,
    renderCell: (params) => {
      const value = params.value;
      const isUnset = value === null || value === undefined || value === "";
      const label = isUnset ? "No" : value ? "Yes" : "No";
      return <Chip label={label} color={value ? "success" : "default"} />;
    },
  },
  {
    field: "chargedDriverAmount",
    headerName: "Driver Charged Amount",
    width: 180,
    valueFormatter: (value) =>
      value !== null && value !== undefined && value !== "" ? `$${value}` : "",
  },
  {
    field: "downloadYardRepairInvoice",
    headerName: "Download Invoice",
    width: 196,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <DownloadButton params={params} type="yardRepairInvoice" />
    ),
  },
  {
    field: "update",
    headerName: "",
    width: 130,
    renderCell: (params) => <UpdateYardRepairPopup yardRepair={params.row} />,
  },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) => (
      <ConfirmActionButton
        id={params.row.id}
        entityType="YardRepair"
        actionType="delete"
        entityLabel="yard repair"
        queryKey="yardRepairs"
        buttonLabel="Delete"
        buttonColor="error"
      />
    ),
  },
];
